import { formatCollectionListDate, formatCollectionPeriod, getCollectionStatusToneBucket, getCollectionTypeLabel, } from "../../../../../model/collection";
import { formattedDate } from "../../../../../utils/date";
import { COBRANZA_APPLY_PAYMENTS_BLOCKED_STATUSES, COBRANZA_APPLY_PAYMENTS_LABEL, COBRANZA_DEFAULT_COLLECTION_OPTION, COBRANZA_PAYMENTS_SUMMARY_LABEL, } from "../../../constants/cobranza.constants";
var REPORT_ENABLED = false;
var STATUS_BUCKET_TO_TONE = {
    IN_PROGRESS: "info",
    COMPLETED: "positive",
    FAILED: "negative",
};
export var useCollectionDetail = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var detail = props.detail;
    if (!detail) {
        return {
            hasDetail: false,
            title: "",
            statusLabel: "",
            statusTone: "info",
            userName: "",
            createdAt: "",
            period: "",
            collectionOption: "",
            productLabels: [],
            files: [],
            report: null,
            applyPaymentsLabel: COBRANZA_APPLY_PAYMENTS_LABEL,
            applyPaymentsDisabled: true,
            onApplyPayments: props.onApplyPayments,
        };
    }
    var reportUrl = (_a = detail.completionSummary) === null || _a === void 0 ? void 0 : _a.report;
    var bucket = getCollectionStatusToneBucket(detail.statusRaw);
    return {
        hasDetail: true,
        title: "".concat(getCollectionTypeLabel((_c = (_b = detail.parameters) === null || _b === void 0 ? void 0 : _b.billingType) !== null && _c !== void 0 ? _c : ""), " \u00B7 ").concat(formatCollectionListDate(detail.createdAt)),
        statusLabel: detail.statusLabel,
        statusTone: (_d = STATUS_BUCKET_TO_TONE[bucket]) !== null && _d !== void 0 ? _d : "info",
        userName: (_f = (_e = detail.parameters) === null || _e === void 0 ? void 0 : _e.userName) !== null && _f !== void 0 ? _f : "",
        createdAt: formattedDate(detail.createdAt),
        period: formatCollectionPeriod((_h = (_g = detail.parameters) === null || _g === void 0 ? void 0 : _g.actualMonth) !== null && _h !== void 0 ? _h : "", (_k = (_j = detail.parameters) === null || _j === void 0 ? void 0 : _j.billingType) !== null && _k !== void 0 ? _k : ""),
        collectionOption: COBRANZA_DEFAULT_COLLECTION_OPTION,
        productLabels: ((_m = (_l = detail.parameters) === null || _l === void 0 ? void 0 : _l.projects) !== null && _m !== void 0 ? _m : [])
            .filter(function (project) { var _a, _b; return ((_b = (_a = detail.parameters) === null || _a === void 0 ? void 0 : _a.projectsId) !== null && _b !== void 0 ? _b : []).includes(project.id); })
            .map(function (project) { return project.description; }),
        files: detail.batchFiles.map(function (file) { return ({
            fileName: file.url.split("/").pop() || file.url,
            url: file.url,
        }); }),
        report: REPORT_ENABLED && reportUrl
            ? { fileName: reportUrl.split("/").pop() || reportUrl, url: reportUrl }
            : null,
        applyPaymentsLabel: bucket === "COMPLETED"
            ? COBRANZA_PAYMENTS_SUMMARY_LABEL
            : COBRANZA_APPLY_PAYMENTS_LABEL,
        applyPaymentsDisabled: COBRANZA_APPLY_PAYMENTS_BLOCKED_STATUSES.includes(detail.statusRaw),
        onApplyPayments: props.onApplyPayments,
    };
};
